var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgChevronLeft(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 12 17' }, props),
        React.createElement("path", { fillRule: 'evenodd', d: 'M7.953 1.116a1.25 1.25 0 011.86 1.666l-.092.102-5.954 5.953 5.954 5.954a1.25 1.25 0 01.091 1.666l-.09.101a1.25 1.25 0 01-1.667.091l-.102-.09L1.116 9.72a1.25 1.25 0 01-.091-1.666l.091-.102 6.837-6.837z' })));
}
export default SvgChevronLeft;
//# sourceMappingURL=ChevronLeft.js.map